import React, { memo, useCallback, useMemo, useRef } from "react";

//components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

//styled components
import { CAROUSEL_DIMENTIONS } from "@dineout-payment-success-ui/constants/Constants";
import { navigateToLink } from "@dineout-payment-success-ui/helpers/nativeBridge";
import { CollectionProps } from "@swiggy-private/checkout-types";
import { ElementObserver } from "@swiggy-private/core-ui";
import { getCarouselConfig } from "@dineout-payment-success-ui/utils/Utils";
import { useDineoutPaymentSuccess } from "@dineout-payment-success-ui/hooks/useDineoutPaymentSuccess";
import { CarouselItemAnchor, Fallback, ImageWrapper } from "./styles";

function CarouselItem(props: CollectionProps): JSX.Element {
    const { onViewItem, index, style } = props;

    const { cloudinaryId, height, href, ariaLabel, width } = getCarouselConfig(props, style);

    const { onCarouselItemClick, onCarouselItemView } = useDineoutPaymentSuccess();

    const visited = useRef<boolean>(false);
    const { id, screenName, entityType, entityId, action } = props;

    const fallback = useMemo(() => <Fallback />, []);

    const onClick = useCallback(() => {
        onCarouselItemClick(id || "");
        navigateToLink(action?.link);
    }, [href, id, screenName]);

    const onView = useCallback(() => {
        onViewItem && onViewItem({ data: { id: id }, index });
        if (!visited.current) {
            visited.current = true;
        }
        onCarouselItemView(id || "");
    }, [screenName, id, entityId, entityType]);

    return (
        <ElementObserver onViewEnter={onView}>
            <CarouselItemAnchor aria-label={ariaLabel} onClick={onClick}>
                <ImageWrapper>
                    <Image
                        alt={ariaLabel}
                        cloudinaryId={cloudinaryId}
                        fallback={fallback}
                        cloudinaryHeight={height * 2}
                        cloudinaryWidth={width * 2}
                        height={String(height)}
                        width={CAROUSEL_DIMENTIONS.ImageWidthvw}
                    />
                </ImageWrapper>
            </CarouselItemAnchor>
        </ElementObserver>
    );
}

export default memo(CarouselItem);
